"use client";
import Blog from "@/components/Landing/Blog/Blog";
import CategorySection from "@/components/Landing/CategorySection/CategorySection";
import LastOffers from "@/components/Landing/LastOffers/LastOffers";
import FourBanner from "@/components/Landing/MultiBanner/FourBanner";
import FourBannerWith2Section from "@/components/Landing/MultiBanner/FourBannerWith2Section";
import OneBanner from "@/components/Landing/MultiBanner/OneBanner";
import SixBannerWith2Section from "@/components/Landing/MultiBanner/SixBannerWith2Section";
import ThreeBanner from "@/components/Landing/MultiBanner/ThreeBanner";
import TwoBanner from "@/components/Landing/MultiBanner/TwoBanner";
import TwoBannerTye6 from "@/components/Landing/MultiBanner/TwoBannerTye6";
import TwoBannerType7 from "@/components/Landing/MultiBanner/TwoBannerType7";
import Offers from "@/components/Landing/Offers/Offers";
import SliderSection from "@/components/Landing/SliderSection/SliderSection";
import TopSale from "@/components/Landing/TopSale/TopSale";
import useTemplates from "@/hooks/useTemplates";
import { TemplatesDataTypes } from "@/types/BannerType";

function Landing() {
  const { data: templatesData } = useTemplates();
  return (
    <div className="min-h-screen flex flex-col">
      <div>
        <SliderSection />
      </div>
      <div className="flex flex-col last:mb-20">
        {templatesData?.data?.map(
          (template: TemplatesDataTypes, index: number) =>
            template?.templateTypeId === 1 ? (
              template?.tileTemplateRS?.tileTemplateTypeId === 1 ? (
                <div
                  style={{ order: Number(template?.position) }}
                  key={index + 1}
                >
                  <OneBanner
                    dataTemplate={template?.tileTemplateRS?.tileTemplateItemRs}
                  />
                </div>
              ) : template?.tileTemplateRS?.tileTemplateTypeId === 2 ? (
                <div
                  style={{ order: Number(template?.position) }}
                  key={index + 1}
                >
                  <TwoBanner
                    dataTemplate={template?.tileTemplateRS?.tileTemplateItemRs}
                  />
                </div>
              ) : template?.tileTemplateRS?.tileTemplateTypeId === 3 ? (
                <div
                  style={{ order: Number(template?.position) }}
                  key={index + 1}
                >
                  <ThreeBanner
                    dataTemplate={template?.tileTemplateRS?.tileTemplateItemRs}
                  />
                </div>
              ) : template?.tileTemplateRS?.tileTemplateTypeId === 4 ? (
                <div
                  style={{ order: Number(template?.position) }}
                  key={index + 1}
                >
                  <FourBanner
                    dataTemplate={template?.tileTemplateRS?.tileTemplateItemRs}
                  />
                </div>
              ) : template?.tileTemplateRS?.tileTemplateTypeId === 5 ? (
                ""
              ) : // <div
              //   style={{ order: Number(template?.position) }}
              //   key={index + 1}
              // >
              //   <FiveBanner
              //     dataTemplate={template?.tileTemplateRS?.tileTemplateItemRs}
              //   />
              // </div>
              template?.tileTemplateRS?.tileTemplateTypeId === 6 ? (
                <div
                  style={{ order: Number(template?.position) }}
                  key={index + 1}
                >
                  <TwoBannerTye6
                    dataTemplate={template?.tileTemplateRS?.tileTemplateItemRs}
                  />
                </div>
              ) : template?.tileTemplateRS?.tileTemplateTypeId === 7 ? (
                <div
                  style={{ order: Number(template?.position) }}
                  key={index + 1}
                >
                  <TwoBannerType7
                    dataTemplate={template?.tileTemplateRS?.tileTemplateItemRs}
                  />
                </div>
              ) : template?.tileTemplateRS?.tileTemplateTypeId === 8 ? (
                <div
                  style={{ order: Number(template?.position) }}
                  key={index + 1}
                >
                  <FourBannerWith2Section
                    dataTemplate={template?.tileTemplateRS?.tileTemplateItemRs}
                  />
                </div>
              ) : template?.tileTemplateRS?.tileTemplateTypeId === 9 ? (
                <div
                  style={{ order: Number(template?.position) }}
                  key={index + 1}
                >
                  <SixBannerWith2Section
                    dataTemplate={template?.tileTemplateRS?.tileTemplateItemRs}
                  />
                </div>
              ) : (
                ""
              )
            ) : template?.templateTypeId === 2 ? (
              template?.specialTemplateId === 1 ? (
                <div
                  style={{ order: Number(template?.position) }}
                  key={index + 1}
                >
                  <CategorySection />
                </div>
              ) : template?.specialTemplateId === 2 ? (
                <div
                  style={{ order: Number(template?.position) }}
                  key={index + 1}
                >
                  <LastOffers />
                </div>
              ) : template?.specialTemplateId === 3 ? (
                <div
                  style={{ order: Number(template?.position) }}
                  key={index + 1}
                >
                  <Offers />
                </div>
              ) : template?.specialTemplateId === 4 ? (
                <div
                  style={{ order: Number(template?.position) }}
                  key={index + 1}
                >
                  <TopSale />
                </div>
              ) : template?.specialTemplateId === 5 ? (
                <div
                  style={{ order: Number(template?.position) }}
                  key={index + 1}
                >
                  <Blog />
                </div>
              ) : (
                ""
              )
            ) : (
              ""
            )
        )}
      </div>

      {/* <div>
        <SuggestionProduct />
      </div> */}
    </div>
  );
}

export default Landing;
